module.exports = __webpack_public_path__ + "img/0cf7df1fe3d44b9b926298b2bfacfbec_mergeImage.5e5b1888.png";